import type { CitationGraph } from "./builders.ts";

const VISUAL_ONLY_ID = /^(?:portal:|extent-anchor:)|-(?:port|portal)(?:-|$)/u;
const JUDGMENT_ID = /^ECLI:[^:\s]+(?::[^:\s]+){2,}$/u;

export function isVisualOnlyDestinationId(id: string): boolean {
  return VISUAL_ONLY_ID.test(id);
}

export function isJudgmentDestinationId(id: string): boolean {
  return JUDGMENT_ID.test(id) && !isVisualOnlyDestinationId(id);
}

export function isSemanticDestination(graph: CitationGraph, id: string): boolean {
  if (!graph.hasNode(id) || isVisualOnlyDestinationId(id)) return false;
  const node = graph.getNodeAttributes(id);
  return node.role === "semantic" && !node.hidden && node.semanticId === id;
}
